export default __webpack_public_path__ + "static/media/hero-shoppinglist@2x.0aee87d6.png";